import React from 'react'
import img from './img/india-g6b59bd7b6_1280.png';
import { useEffect } from 'react';
import Typed from 'typed.js';
import { Link } from 'react-router-dom';
import resume from './Resume/Ansh_Varshney.pdf'
import { FaBeer } from 'react-icons/fa';
import { useState } from 'react';
const Hero = () => {
    useEffect(() => {
        const typed = new Typed('#typed-text', {
            strings: ['Web Designer', 'Web Developer', 'Freelancer', 'Python Gui Developer'],
            typeSpeed: 50,
            loop: true
        });
        return () => {
            typed.destroy();
        };
    }, []);

    function handleDownload() {
        const link = document.createElement('a');
        link.href = resume;
        link.download = 'Ansh_Varshney.pdf';
        link.click();
    }

    const handleBackToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData(prevState => ({ ...prevState, [name]: value }));
    }
    const [submit, issubmit] = useState(false);
    const handleSubmit = (event) => {
        event.preventDefault();

        fetch('https://details-production.up.railway.app/registrations/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        })
            .then(response => {
                if (response.ok) {
                    // TODO: handle successful submission
                    console.log('Form submitted successfully');
                    issubmit(true)
                    setFormData({
                        name: '',
                        email: '',
                        subject: '',
                        message: ''
                    });
                } else {
                    // TODO: handle error response
                    console.error('Form submission failed');
                }
            })
            .catch(error => {
                // TODO: handle fetch error
                console.error(error);
            });
        setFormData("");

    }



    return (
        <>
            <section id="hero" class="d-flex flex-column justify-content-center align-items-center">
                <div class="hero-container" data-aos="fade-in">
                    <h1>Ansh Varshney</h1>
                    <p>I'm <span id="typed-text" data-typed-items="Web Designer, Web Developer, Freelancer, Python Gui Developer"></span></p>
                </div>
            </section>

            <main id="main">
                <section id="about" class="about">
                    <div class="container">

                        <div class="section-title">
                            <h2>About</h2>
                            <p>“Self-motivated, highly passionate and hardworking fresher looking for an opportunity to work in a challenging organization to utilize my skills and knowledge to work for the growth of the organisation.”.</p>
                        </div>

                        <div class="row">
                            <div class="col-lg-4" data-aos="fade-right">
                                <img src="assets/img/profile-img.png" class="img-fluid" alt="" />
                            </div>
                            <div class="col-lg-8 pt-4 pt-lg-0 content" data-aos="fade-left">
                                <h3> Web Developer &amp; UI/UX Designer</h3>
                                <p class="fst-italic">
                                    A web developer resume should include a tech table that lists all of the software and tools that the candidate is experienced in using for web design.
                                    <br />
                                    Common software and web development tools include Visual Studio Code , Django/Flask, HTML, CSS, C#, JavaScript, Git Hub, Bootstrap, Tailwind Css, SEO, UI/UX, and Python. .
                                </p>
                                <div class="row">
                                    <div class="col-lg-6">
                                        <ul>
                                            <li><i class="bi bi-chevron-right"></i> <strong>Website:</strong> <span><a href="https://anshvarshney.up.railway.app/">anshvarshney.up.railway.app</a></span></li>
                                            <li><i class="bi bi-chevron-right"></i> <strong>Phone:</strong> <span>+91 8178-7566-58</span></li>
                                            <li><i class="bi bi-chevron-right"></i> <strong>City:</strong> <span>Delhi, India</span></li>
                                        </ul>
                                    </div>
                                    <div class="col-lg-6">
                                        <ul>

                                            <li><i class="bi bi-chevron-right"></i> <strong>Degree:</strong> <span>B.C.A </span></li>
                                            <li><i class="bi bi-chevron-right"></i> <strong>Email:</strong> <span>ansh.varshney20libra@gmail.com</span></li>
                                            <li><i class="bi bi-chevron-right"></i> <strong>Freelance:</strong> <span>Available</span></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section id="skills" class="skills section-bg">
                    <div class="container">

                        <div class="section-title">
                            <h2>Skills</h2>
                        </div>

                        <div class="row skills-content">

                            <div class="col-lg-6" data-aos="fade-up">

                                <div class="progress">
                                    <span class="skill">HTML <i class="val">80%</i></span>
                                    <div class="progress-bar-wrap">
                                        <div class="progress">
                                            <div class="progress-bar w-75" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100"></div>
                                        </div>
                                    </div>
                                </div>

                                <div class="progress">
                                    <span class="skill">CSS <i class="val">60%</i></span>
                                    <div class="progress-bar-wrap">
                                        <div class="progress">
                                            <div class="progress-bar w-75" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100"></div>
                                        </div>
                                    </div>
                                </div>

                                <div class="progress">
                                    <span class="skill">Python Django <i class="val">70%</i></span>
                                    <div class="progress-bar-wrap">
                                        <div class="progress-bar w-75" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"></div>
                                    </div>
                                </div>

                                <div class="progress">
                                    <span class="skill">JavaScript <i class="val">60%</i></span>
                                    <div class="progress-bar-wrap">
                                        <div class="progress-bar w-75" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100"></div>
                                    </div>
                                </div>

                                <div class="progress">
                                    <span class="skill">Nginx / Gunicorn<i class="val">60%</i></span>
                                    <div class="progress-bar-wrap">
                                        <div class="progress-bar w-75" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100"></div>
                                    </div>
                                </div>

                            </div>

                            <div class="col-lg-6" data-aos="fade-up" data-aos-delay="100">

                                <div class="progress">
                                    <span class="skill">PHP <i class="val">60%</i></span>
                                    <div class="progress-bar-wrap">
                                        <div class="progress-bar w-75" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100"></div>
                                    </div>
                                </div>

                                <div class="progress">
                                    <span class="skill">WordPress/CMS <i class="val">70%</i></span>
                                    <div class="progress-bar-wrap">
                                        <div class="progress-bar w-75" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"></div>
                                    </div>
                                </div>

                                <div class="progress">
                                    <span class="skill">Python GUI <i class="val">75%</i></span>
                                    <div class="progress-bar-wrap">
                                        <div class="progress-bar w-75" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"></div>
                                    </div>
                                </div>

                                <div class="progress">
                                    <span class="skill">React Js / Next Js<i class="val">65%</i></span>
                                    <div class="progress-bar-wrap">
                                        <div class="progress-bar w-75" role="progressbar" aria-valuenow="65" aria-valuemin="0" aria-valuemax="100"></div>
                                    </div>
                                </div>

                                <div class="progress">
                                    <span class="skill">Git / Github<i class="val">80%</i></span>
                                    <div class="progress-bar-wrap">
                                        <div class="progress-bar w-75" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100"></div>
                                    </div>
                                </div>


                            </div>

                        </div>

                    </div>




                    <br />
                    <section>
                        <div class="container">
                            <div class="section-title">
                                <h2>Online Learning Certificates</h2>
                            </div>
                            <div class="container">
                                <marquee scrollamount="10" >
                                    <div class="col-lg-4 col-md-6 portfolio-item filter-web">
                                        <div class="portfolio-wrap">
                                            <img src="assets/img/portfolio/Certificates/certificate-1.jpg" class="img-fluid" alt="" />
                                            <img src="assets/img/portfolio/Certificates/certificate-2.jpg" class="img-fluid" alt="" />
                                            <img src="assets/img/portfolio/Certificates/certificate-3.jpg" class="img-fluid" alt="" />
                                            <img src="assets/img/portfolio/Certificates/certificate-4.jpg" class="img-fluid" alt="" />
                                            <img src="assets/img/portfolio/Certificates/certificate-5.jpg" class="img-fluid" alt="" />
                                            <img src="assets/img/portfolio/Certificates/certificate-6.jpg" class="img-fluid" alt="" />
                                            <img src="assets/img/portfolio/Certificates/certificate-7.jpg" class="img-fluid" alt="" />
                                            <img src="assets/img/portfolio/Certificates/certificate-8.jpg" class="img-fluid" alt="" />
                                            <img src="assets/img/portfolio/Certificates/certificate-9.jpg" class="img-fluid" alt="" />
                                            <img src="assets/img/portfolio/Certificates/certificate-10.jpg" class="img-fluid" alt="" />
                                            <img src="assets/img/portfolio/Certificates/certificate-11.png" class="img-fluid" alt="" />
                                        </div>
                                    </div>
                                </marquee>
                            </div>

                        </div>
                    </section>
                </section>
                <section id="resume" className="resume">
                    <div className="container">

                        <div className="section-title">
                            <h2>Resume</h2>
                            <p>A resume is a formal document used to provide an overview of a person's education, work experience, skills, and accomplishments to potential employers.</p>
                        </div>

                        <div className="row">
                            <div className="col-lg-6" data-aos="fade-up">
                                <h3 className="resume-title">Summary</h3>
                                <div className="resume-item pb-0">
                                    <h4>Ansh Varshney</h4>
                                    <p><em>Innovative and deadline-driven Web Designer with 1 years of experience designing and developing user-centered digital/print marketing material from initial concept to final, polished deliverable.</em></p>
                                    <ul>
                                        <li>Delhi, India</li>
                                        <li>(+91) 8178 7566 58</li>
                                        <li><a href="mailto:ansh.varshney20libra@gmail.com">ansh.varshney20libra@gmail.com</a></li>
                                    </ul>
                                </div>

                                <h3 className="resume-title">Experience</h3>
                                <div className="resume-item">
                                    <h4>Connect and Collabs (Hyderabad,India)</h4>
                                    <h5>Software Devloper</h5>
                                    <p><em>April 2022 - August 2023</em></p>
                                    <p>I Had a responsibility is to write clean, maintainable, and efficient code according to specifications provided by project managers or clients. <br /> Implemented software solutions using appropriate programming languages, frameworks, and libraries, ensuring code quality through practices like unit testing and code reviews.</p>
                                </div>
                                <div className="resume-item">
                                    <h4>Invexi Pvt Ltd (Singapore)</h4>
                                    <h5>Python Developer</h5>
                                    <p><em>Augut 2023 - Dec 2023</em></p>
                                    <p>Guru Gobind Singh Indraprastha University, formerly Indraprastha University (IP or IPU), is a state university located in Delhi, India. It was established in 1998 as a teaching-cum-affiliating university</p>
                                </div>
                            </div>
                            <div className="col-lg-6" data-aos="fade-up" data-aos-delay="100">
                                <h3 className="resume-title">Professional Project Experience</h3>
                                <div className="resume-item">
                                    <h4>Dynamic Projects</h4>
                                    <h5>Movie Booking</h5>
                                    <br />
                                    <button type="button" style={{ backgroundColor: '#149ddd', border: '0', padding: '10px 24px', color: '#fff', transition: '0.4s', borderRadius: '4px' }}><a href="https://movie-site-booking.netlify.app/" style={{ color: 'white' }}>View Onsite</a></button>
                                    <br /><br />
                                    <p><em> Language Used : Javascript, Library - React Js, Bootstrap 5 </em></p>
                                    <hr />
                                    <h5>Hotel Booking</h5>
                                    <br />
                                    <button type="button" style={{ backgroundColor: '#149ddd', border: '0', padding: '10px 24px', color: '#fff', transition: '0.4s', borderRadius: '4px' }}><a href="https://holidu.com/" style={{ color: 'white' }}>View Onsite</a></button>
                                    <br /><br />
                                    <p><em> Language Used : Javascript, Library - React Js,Redux,Flask API,MongoDB Tailwind CSS </em></p>
                                    <hr />
                                    <h5>Digital Currency Converter</h5>
                                    <br />
                                    <button type="button" style={{ backgroundColor: "#149ddd", border: "0", padding: "10px 24px", color: "#fff", transition: "0.4s", borderRadius: "4px" }}>
                                        <a href="https://movex-main-v2.vercel.app" style={{ color: "white" }}>View Onsite</a>
                                    </button>
                                    <br /><br />
                                    <p><em>Language Used: JavaScript, Library - React JS, Third Party API,Bootstrap CSS</em></p>
                                    <hr />
                                    <h4>Python Django Development</h4>
                                    <h5>News API Django</h5>
                                    <br />
                                    <button type="button" style={{ backgroundColor: "#149ddd", border: "0", padding: "10px 24px", color: "#fff", transition: "0.4s", borderRadius: "4px" }}>
                                        <a href="https://dailynews-production.up.railway.app/" style={{ color: "white" }}>View Onsite</a></button>
                                    <br /><br />
                                    <p><em> Language Used : Wordpress,Django,Tailwinds Css </em></p>
                                    <hr />
                                    <h5>Fast Api Collection</h5>
                                    <br />
                                    <button type="btn" style={{ backgroundColor: "#149ddd", border: "0", padding: "10px 24px", color: "#fff", transition: "0.4s", borderRadius: "4px" }}><a href="
https://kriya-backend-api.onrender.com/docs" style={{ color: "white" }}>View Onsite</a></button>
                                    <br /><br />
                                    <p><em> Language Used : Python , FastAPI, MongoDB </em></p>
                                    <br />
                                    <h5>Kriya (Creator's Web App)</h5>
                                    <br />
                                    <button type="btn" style={{ backgroundColor: "#149ddd", border: "0", padding: "10px 24px", color: "#fff", transition: "0.4s", borderRadius: "4px" }}><a href="https://creatorsapp.in/" style={{ color: "white" }}>View Onsite</a></button>
                                    <br /><br />
                                    <p><em> Language Used : Django REST API,React Js,Firebase </em></p>
                                    <hr />
                                    <h5>Django Fun Recoder Panel</h5>
                                    <br />
                                    <button type="btn" style={{ backgroundColor: "#149ddd", border: "0", padding: "10px 24px", color: "#fff", transition: "0.4s", borderRadius: "4px" }}><a href="https://funrecoder-production.up.railway.app/" style={{ color: "white" }}>View Onsite</a></button>
                                    <br /><br />
                                    <p><em> Language Used : Django Core </em></p>
                                    <hr />
                                </div>
                                <div class="resume-item">
                                    <h4>Wordpress Sites</h4>
                                    <h5>Business Site</h5>
                                    <br />
                                    <button type="btn" style={{ backgroundColor: "#149ddd", border: "0", padding: "10px 24px", color: "#fff", transition: "0.4s", borderRadius: "4px" }}><a href="https://web23.blogdu.de/" style={{ color: "white" }}>View Onsite</a></button>
                                    <br /><br />
                                    <p><em> Wordpress,Cpanel,Hestia,PHP </em></p>
                                    <hr />
                                    <h5>E-Commerce Site</h5>
                                    <br />
                                    <button type="btn" style={{ backgroundColor: "#149ddd", border: "0", padding: "10px 24px", color: "#fff", transition: "0.4s", borderRadius: "4px" }}><a href="https://shop2024.blogdu.de/" style={{ color: "white" }}>View Onsite</a></button>
                                    <br /><br />
                                    <p><em> Wordpress,Cpanel,Hestia,PHP  </em></p>
                                    <hr />
                                </div>
                                <div class="resume-item">
                                    <h4>Wordpress</h4>
                                    <h5>Student Database Management System</h5>
                                    <br />
                                    <button type="btn" style={{ backgroundColor: "#149ddd", border: "0", padding: "10px 24px", color: "#fff", transition: "0.4s", borderRadius: "4px" }}><Link to="guidetails" style={{ color: "white" }}>View Onsite</Link></button>
                                    <br /><br />
                                    <p><em> Language Used : OOPS Python </em></p>
                                    <hr />
                                    <h5>Random Password Generator</h5>
                                    <br />
                                    <button type="btn" style={{ backgroundColor: "#149ddd", border: "0", padding: "10px 24px", color: "#fff", transition: "0.4s", borderRadius: "4px" }}><Link to="guidetails" style={{ color: "white" }}>View Onsite</Link></button>
                                    <br /><br />
                                    <p><em> Language Used : OOPS Python </em></p>
                                    <hr />
                                </div>

                            </div>
                            <div className="col-lg-6" data-aos="fade-up" data-aos-delay="100">
                                <h3 className="resume-title">Professional Project Experience</h3>
                                <div className="resume-item">
                                    <h4>Dynamic Projects</h4>
                                    <h5>Movie Booking</h5>
                                    <br />
                                    <button type="button" style={{ backgroundColor: '#149ddd', border: '0', padding: '10px 24px', color: '#fff', transition: '0.4s', borderRadius: '4px' }}><a href="https://movie-site-booking.netlify.app/" style={{ color: 'white' }}>View Onsite</a></button>
                                    <br /><br />
                                    <p><em> Language Used : Javascript, Library - React Js, Bootstrap 5 </em></p>
                                    <hr />
                                    <h5>Hotel Booking</h5>
                                    <br />
                                    <button type="button" style={{ backgroundColor: '#149ddd', border: '0', padding: '10px 24px', color: '#fff', transition: '0.4s', borderRadius: '4px' }}><a href="https://holidu.com/" style={{ color: 'white' }}>View Onsite</a></button>
                                    <br /><br />
                                    <p><em> Language Used : Javascript, Library - React Js,Redux,Flask API,MongoDB Tailwind CSS </em></p>
                                    <hr />
                                    <h5>Digital Currency Converter</h5>
                                    <br />
                                    <button type="button" style={{ backgroundColor: "#149ddd", border: "0", padding: "10px 24px", color: "#fff", transition: "0.4s", borderRadius: "4px" }}>
                                        <a href="https://movex-main-v2.vercel.app" style={{ color: "white" }}>View Onsite</a>
                                    </button>
                                    <br /><br />
                                    <p><em>Language Used: JavaScript, Library - React JS, Third Party API,Bootstrap CSS</em></p>
                                    <hr />
                                    <h4>Python Django Development</h4>
                                    <h5>News API Django</h5>
                                    <br />
                                    <button type="button" style={{ backgroundColor: "#149ddd", border: "0", padding: "10px 24px", color: "#fff", transition: "0.4s", borderRadius: "4px" }}>
                                        <a href="https://dailynews-production.up.railway.app/" style={{ color: "white" }}>View Onsite</a></button>
                                    <br /><br />
                                    <p><em> Language Used : Wordpress,Django,Tailwinds Css </em></p>
                                    <hr />
                                    <h5>Fast Api Collection</h5>
                                    <br />
                                    <button type="btn" style={{ backgroundColor: "#149ddd", border: "0", padding: "10px 24px", color: "#fff", transition: "0.4s", borderRadius: "4px" }}><a href="
https://kriya-backend-api.onrender.com/docs" style={{ color: "white" }}>View Onsite</a></button>
                                    <br /><br />
                                    <p><em> Language Used : Python , FastAPI, MongoDB </em></p>
                                    <br />
                                    <h5>Kriya (Creator's Web App)</h5>
                                    <br />
                                    <button type="btn" style={{ backgroundColor: "#149ddd", border: "0", padding: "10px 24px", color: "#fff", transition: "0.4s", borderRadius: "4px" }}><a href="https://creatorsapp.in/" style={{ color: "white" }}>View Onsite</a></button>
                                    <br /><br />
                                    <p><em> Language Used : Django REST API,React Js,Firebase </em></p>
                                    <hr />
                                    <h5>Django Fun Recoder Panel</h5>
                                    <br />
                                    <button type="btn" style={{ backgroundColor: "#149ddd", border: "0", padding: "10px 24px", color: "#fff", transition: "0.4s", borderRadius: "4px" }}><a href="https://funrecoder-production.up.railway.app/" style={{ color: "white" }}>View Onsite</a></button>
                                    <br /><br />
                                    <p><em> Language Used : Django Core </em></p>
                                    <hr />
                                </div>
                                <div class="resume-item">
                                    <h4>PHP Development</h4>
                                    <h5>User Authentication Webpage</h5>
                                    <br />
                                    <button type="btn" style={{ backgroundColor: "#149ddd", border: "0", padding: "10px 24px", color: "#fff", transition: "0.4s", borderRadius: "4px" }}><a href="http://avproject.42web.io/" style={{ color: "white" }}>View Onsite</a></button>
                                    <br /><br />
                                    <p><em> Language Used : Bootstrap , PHP , Mysql </em></p>
                                    <hr />
                                    <h5>Homepage Website</h5>
                                    <br />
                                    <button type="btn" style={{ backgroundColor: "#149ddd", border: "0", padding: "10px 24px", color: "#fff", transition: "0.4s", borderRadius: "4px" }}><a href="https://pycode-hub.netlify.app/" style={{ color: "white" }}>View Onsite</a></button>
                                    <br /><br />
                                    <p><em> Language Used : HTML 5, Bootstrap , PHP  </em></p>
                                    <hr />
                                </div>
                                <div class="resume-item">
                                    <h4>Desktop Applications</h4>
                                    <h5>Student Database Management System</h5>
                                    <br />
                                    <button type="btn" style={{ backgroundColor: "#149ddd", border: "0", padding: "10px 24px", color: "#fff", transition: "0.4s", borderRadius: "4px" }}><Link to="guidetails" style={{ color: "white" }}>View Onsite</Link></button>
                                    <br /><br />
                                    <p><em> Language Used : OOPS Python </em></p>
                                    <hr />
                                    <h5>Random Password Generator</h5>
                                    <br />
                                    <button type="btn" style={{ backgroundColor: "#149ddd", border: "0", padding: "10px 24px", color: "#fff", transition: "0.4s", borderRadius: "4px" }}><Link to="guidetails" style={{ color: "white" }}>View Onsite</Link></button>
                                    <br /><br />
                                    <p><em> Language Used : OOPS Python </em></p>
                                    <hr />
                                </div>

                            </div>
                            <div class="text-center"><button type="btn" onClick={handleDownload} style={{ backgroundColor: "#149ddd", border: "0", padding: "10px 24px", color: "#fff", transition: "0.4s", borderRadius: "4px", color: "white" }}>Download CV</button></div>
                        </div>
                    </div>
                </section>
                <section id="portfolio" class="portfolio section-bg">
                    <div class="container">

                        <div class="section-title">
                            <h2>Web Design Portfolio</h2>
                            <p>A Portfolios are considered a point of introduction where designers have their first opportunity to introduce themselves, their personality, their artistic style, professionalism, and so on. Web design portfolios can include anything from live websites that the designer built, sample projects, case studies, web design templates, or even smaller-scale assets such as typography design, illustrations, logos, etc. </p>
                        </div>

                        <div class="row" data-aos="fade-up">
                            <div class="col-lg-12 d-flex justify-content-center">
                                <ul id="portfolio-flters">
                                    <li data-filter="*" class="filter-active">All</li>
                                    <li data-filter=".filter-app">Figma App Designs</li>
                                    <li data-filter=".filter-web">Figma Web Designs</li>
                                </ul>
                            </div>
                        </div>

                        <div class="row portfolio-container" data-aos="fade-up" data-aos-delay="100">

                            <div class="col-lg-4 col-md-6 portfolio-item filter-app">
                                <div class="portfolio-wrap">
                                    <img src="assets/img/portfolio/mobile/portfolio-1.png" class="img-fluid" alt="" />
                                    <div class="portfolio-links">
                                        <a href="assets/img/portfolio/mobile/portfolio-1.png" data-gallery="portfolioGallery" class="portfolio-lightbox" title="App-Design 1"><i class="bx bx-server"></i></a>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-6 portfolio-item filter-app">
                                <div class="portfolio-wrap">
                                    <img src="assets/img/portfolio/mobile/portfolio-2.png" class="img-fluid" alt="" />
                                    <div class="portfolio-links">
                                        <a href="assets/img/portfolio/mobile/portfolio-2.png" data-gallery="portfolioGallery" class="portfolio-lightbox" title="App-Design 2"><i class="bx bx-server"></i></a>

                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-6 portfolio-item filter-app">
                                <div class="portfolio-wrap">
                                    <img src="assets/img/portfolio/mobile/portfolio-3.png" class="img-fluid" alt="" />
                                    <div class="portfolio-links">
                                        <a href="assets/img/portfolio/mobile/portfolio-3.png" data-gallery="portfolioGallery" class="portfolio-lightbox" title="App-Design 2"><i class="bx bx-server"></i></a>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-6 portfolio-item filter-app">
                                <div class="portfolio-wrap">
                                    <img src="assets/img/portfolio/mobile/portfolio-4.png" class="img-fluid" alt="" />
                                    <div class="portfolio-links">
                                        <a href="assets/img/portfolio/mobile/portfolio-4.png" data-gallery="portfolioGallery" class="portfolio-lightbox" title="App-Design 3"><i class="bx bx-server"></i></a>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-6 portfolio-item filter-app">
                                <div class="portfolio-wrap">
                                    <img src="assets/img/portfolio/mobile/portfolio-5.png" class="img-fluid" alt="" />
                                    <div class="portfolio-links">
                                        <a href="assets/img/portfolio/mobile/portfolio-4.png" title="More Details"><i class="bx bx-server"></i></a>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-6 portfolio-item filter-web">
                                <div class="portfolio-wrap">
                                    <img src="assets/img/portfolio/web/portfolio-a.png" class="img-fluid" alt="" />
                                    <div class="portfolio-links">
                                        <a href="assets/img/portfolio/web/portfolio-a.png" data-gallery="portfolioGallery" class="portfolio-lightbox" title="Web-Design 1"><i class="bx bx-server"></i></a>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-6 portfolio-item filter-web">
                                <div class="portfolio-wrap">
                                    <img src="assets/img/portfolio/web/portfolio-b.png" class="img-fluid" alt="" />
                                    <div class="portfolio-links">
                                        <a href="assets/img/portfolio/web/portfolio-b.png" data-gallery="portfolioGallery" class="portfolio-lightbox" title="Web-Design 2"><i class="bx bx-server"></i></a>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-6 portfolio-item filter-web">
                                <div class="portfolio-wrap">
                                    <img src="assets/img/portfolio/web/portfolio-c.png" class="img-fluid" alt="" />
                                    <div class="portfolio-links">
                                        <a href="assets/img/portfolio/web/portfolio-c.png" data-gallery="portfolioGallery" class="portfolio-lightbox" title="Web-Design 3"><i class="bx bx-server"></i></a>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-6 portfolio-item filter-web">
                                <div class="portfolio-wrap">
                                    <img src="assets/img/portfolio/web/portfolio-d.png" class="img-fluid" alt="" />
                                    <div class="portfolio-links">
                                        <a href="assets/img/portfolio/web/portfolio-d.png" data-gallery="portfolioGallery" class="portfolio-lightbox" title="Web-Design 4"><i class="bx bx-server"></i></a>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-6 portfolio-item filter-card">
                                <div class="portfolio-wrap">
                                    <img src="assets/img/portfolio/portfolio-8.jpg" class="img-fluid" alt="" />
                                    <div class="portfolio-links">
                                        <a href="assets/img/portfolio/portfolio-8.jpg" data-gallery="portfolioGallery" class="portfolio-lightbox" title="Card 3"><i class="bx bx-server"></i></a>
                                    </div>
                                </div>
                            </div>

                        </div>


                    </div>
                </section>
                <section id="contact" className="contact">
                    <div className="container">

                        <div className="section-title">
                            <h2>Contact Me</h2>
                        </div>

                        <div className="row" data-aos="fade-in">

                            <div className="col-lg-5 d-flex align-items-stretch">
                                <div className="info">
                                    <div className="address">
                                        <i className="bi bi-geo-alt"></i>
                                        <h4>Location:</h4>
                                        <p>Delhi, India</p>
                                    </div>

                                    <div className="email">
                                        <i className="bi bi-envelope"></i>
                                        <h4>Email:</h4>
                                        <p>ansh.varshney20libra@gmail.com</p>
                                    </div>

                                    <div className="phone">
                                        <i className="bi bi-phone"></i>
                                        <h4>Call:</h4>
                                        <p>+91 8178 7566 658</p>
                                    </div>

                                    <img src={img} style={{ border: '0', width: '100%', height: '290px' }} alt="location" />
                                </div>

                            </div>

                            <div className="col-lg-7 mt-5 mt-lg-0 d-flex align-items-stretch">
                                <form action="#contact" role="form" className="php-email-form" onSubmit={handleSubmit}>
                                    <div className="row">
                                        <div className="form-group col-md-6">
                                            <label htmlFor="name">Your Name</label>
                                            <input type="text" name="name" className="form-control" id="name" required value={formData.name} onChange={handleChange} />
                                        </div>
                                        <div className="form-group col-md-6">
                                            <label htmlFor="email">Your Email</label>
                                            <input type="email" className="form-control" name="email" id="email" required value={formData.email} onChange={handleChange} />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="subject">Subject</label>
                                        <input type="text" className="form-control" name="subject" id="subject" required value={formData.subject} onChange={handleChange} />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="message">Message</label>
                                        <textarea className="form-control" name="message" rows="10" required value={formData.message} onChange={handleChange}></textarea>
                                    </div>
                                    {submit && <p style={{ textAlign: "center" }}>Your Response Successfully Submitted</p>}
                                    <div className="text-center">
                                        <button type="submit">Send Message</button>
                                    </div>
                                </form>
                            </div>

                        </div>

                    </div>
                </section>

            </main>

        </>
    )
}

export default Hero